import React from "react";
import { Modal, ModalHeader, ModalBody } from "reactstrap";
import { Controller, useForm } from "react-hook-form";
import MaskedInput from "react-text-mask";
import createNumberMask from "text-mask-addons/dist/createNumberMask";
import { formatDB } from "../../../components/Utils/Currency";
import SelectSearchBootstrap from "../../../components/InputSelectSearch/SelectSearchBootstrap";
import { useMutation } from "react-query";
import DeliveryService from "../../../Services/DeliveryService";
import { handleError } from "../../../components/Utils/Utils";
import { notifUtils } from "../../../components/NotifUtils/NotifUtils";

const FormDialog = (props) => {
  const {
    isShow,
    onClose,
    type = "add",
    formData,
    vendorData,
    refetch,
  } = props;
  const [isCOD, setIsCOD] = React.useState("0");
  const [optionsConsigneeType, setOptionsConsigneeType] = React.useState([
    {
      value: "address",
      name: "Address",
    },
    {
      value: "room",
      name: "Room",
    },
    {
      value: "table",
      name: "Table",
    },
  ]);

  const numberMask = (allowDecimal) => {
    return createNumberMask({
      prefix: "",
      sufix: "",
      includeThousandsSeparator: true,
      thousandsSeparatorSymbol: ".",
      allowDecimal: allowDecimal,
      decimalSymbol: ",",
    });
  };

  const {
    register,
    handleSubmit,
    setValue,
    formState: { errors, isValid },
    control,
    watch,
    reset,
  } = useForm({
    mode: "all",
    reValidateMode: "onChange",
    shouldUnregister: false,
  });

  const watchFields = watch();

  const handleToggle = () => {
    onClose();
  };

  const handleCancel = () => {
    reset({});
    handleToggle();
  };

  const mutationPropertyDelivery = useMutation(
    type === "add"
      ? DeliveryService.postDeliveryPackage
      : DeliveryService.putDeliveryPackage,
    {
      onSuccess: (data) => {
        notifUtils(
          type === "add"
            ? "Success Add New Delivery Package"
            : "Success Update Delivery Package",
          "success"
        );
        handleCancel();
        refetch();
      },
      onError: (error) => {
        handleError(error);
      },
    }
  );

  const onSubmit = (data) => {
    const params = data;
    console.log(params);
    params.base_fee =
      params.base_fee !== ""
        ? parseFloat(
            formatDB(
              params.base_fee
                .toString()
                .replace(process.env.REACT_APP_CURRENCY_SYMBOL, "")
            )
          )
        : 0;
    params.max_distance_value =
      params.max_distance_value !== ""
        ? parseFloat(formatDB(params.max_distance_value))
        : 0;
    params.max_distance_free =
      params.max_distance_free !== ""
        ? parseFloat(formatDB(params.max_distance_free))
        : 0;
    params.max_weight_value =
      params.max_weight_value !== ""
        ? parseFloat(formatDB(params.max_weight_value))
        : 0;
    params.max_dimension_length =
      params.max_dimension_length !== ""
        ? parseFloat(formatDB(params.max_dimension_length))
        : 0;
    params.max_dimension_width =
      params.max_dimension_width !== ""
        ? parseFloat(formatDB(params.max_dimension_width))
        : 0;
    params.max_dimension_height =
      params.max_dimension_height !== ""
        ? parseFloat(formatDB(params.max_dimension_height))
        : 0;

    mutationPropertyDelivery.mutate(params);
  };

  const handleChangeIsCOD = (e) => {
    const val = e.target.value === "1" ? true : false;
    setIsCOD(e.target.value);
    setValue("is_cod", val);
  };

  React.useEffect(() => {
    if (isShow) {
      if (formData !== "") {
        reset(formData);
        setIsCOD(formData?.is_cod ? "1" : "0");
      } else {
        reset({
          group: {
            id: 0,
          },
          vendor: {
            id: vendorData?.id,
          },
          cons_type: "address",
          is_manual: true,
          is_cod: false,
          active_st: false,
          max_distance_value: 0,
          max_distance_free: 0,
          max_weight_value: 0,
          max_distance_length: 0,
          max_distance_width: 0,
          max_distance_height: 0,
        });
      }
    }
  }, [isShow]);

  React.useEffect(() => {
    if (
      (watchFields?.cons_type && watchFields?.cons_type !== "address") ||
      isCOD === "1"
    ) {
      setValue("base_fee", 0);
      setValue("max_distance_value", 0);
      setValue("max_distance_free", 0);
      setValue("max_weight_value", 0);
      setValue("max_distance_length", 0);
      setValue("max_distance_width", 0);
      setValue("max_distance_height", 0);
    }
  }, [watchFields["cons_type"], isCOD]);

  return (
    <Modal
      isOpen={isShow}
      toggle={handleToggle}
      backdrop={false}
      centered={true}
      size="lg"
      zIndex={1300}
      modalClassName="modal-custom"
    >
      <ModalHeader toggle={handleToggle}>
        {type === "add" ? "Add" : "Edit"} Delivery Package
      </ModalHeader>
      <ModalBody>
        <form onSubmit={handleSubmit(onSubmit)}>
          <div className="card border-0 rounded-8px">
            <div className="card-body p-4">
              <div className="row">
                <div className="col-md-6 col-12">
                  <div className="form-group mb-4">
                    <label
                      htmlFor="name"
                      className="font-12 font-bold d-flex justify-content-between align-items-center"
                    >
                      <span>Delivery Package Name</span>
                      <span className="font-bold text-muted">
                        {watchFields["name"]?.length || 0} / 150
                      </span>
                    </label>
                    <input
                      type="text"
                      id="name"
                      name="name"
                      className="form-control rounded-8px"
                      {...register("name", {
                        required: "Please input package name",
                        maxLength: {
                          value: 150,
                          message: "Maximum character 150",
                        },
                      })}
                    />
                    {errors.name && (
                      <small className="form-text text-error">
                        {errors?.name?.message}
                      </small>
                    )}
                  </div>
                </div>
                <div className="col-md-6 col-12">
                  <div className="form-group mb-4">
                    <label
                      htmlFor="package_code"
                      className="font-12 font-bold d-flex justify-content-between align-items-center"
                    >
                      <span>Package Code</span>
                      <span className="font-bold text-muted">
                        {watchFields["package_code"]?.length || 0} / 25
                      </span>
                    </label>
                    <input
                      type="text"
                      id="package_code"
                      name="package_code"
                      className="form-control rounded-8px"
                      {...register("package_code", {
                        maxLength: {
                          value: 25,
                          message: "Maximum character 25",
                        },
                      })}
                    />
                    {errors.package_code && (
                      <small className="form-text text-error">
                        {errors?.package_code?.message}
                      </small>
                    )}
                  </div>
                </div>
                <div className="col-12">
                  <div className="form-group mb-4">
                    <label
                      htmlFor="description"
                      className="font-12 font-bold d-flex justify-content-between align-items-center"
                    >
                      <span>Description</span>
                      <span className="font-bold text-muted">
                        {watchFields["description"]?.length || 0} / 250
                      </span>
                    </label>
                    <textarea
                      className="form-control rounded-8px"
                      name="description"
                      {...register("description", {
                        maxLength: {
                          value: 250,
                          message: "Max 250 character",
                        },
                      })}
                      rows="3"
                    ></textarea>
                    {errors.description && (
                      <small className="form-text text-error">
                        {errors?.description?.message}
                      </small>
                    )}
                  </div>
                </div>
                {/* <div className="col-md-6 col-12">
                  <div className="form-group mb-4">
                    <label
                      htmlFor="cons_type"
                      className="font-12 font-bold d-flex justify-content-between align-items-center"
                    >
                      <span>Select Consignee Type</span>
                    </label>
                    <Controller
                      name="cons_type"
                      control={control}
                      render={({ field }) => (
                        <SelectSearchBootstrap
                          {...field}
                          options={optionsConsigneeType}
                          search
                          closeOnSelect={true}
                          placeholder="Search for consignee type"
                          value={
                            watchFields["cons_type"]
                              ? watchFields["cons_type"]
                              : ""
                          }
                        />
                      )}
                      rules={{
                        required: "Please select consignee type",
                      }}
                      defaultValue={watchFields["cons_type"] || ""}
                    />
                    {errors.cons_type && (
                      <small className="form-text text-error">
                        {errors?.cons_type?.message}
                      </small>
                    )}
                  </div>
                </div> */}
                {watchFields["cons_type"] &&
                  watchFields["cons_type"] === "address" && (
                    <div className="col-md-6 col-12">
                      <label
                        htmlFor="max_weight_value"
                        className="font-12 font-bold d-flex justify-content-between align-items-center"
                      >
                        <span>COD</span>
                      </label>
                      <div className="row">
                        <div className="col-md-3 col-sm-12 col-12">
                          <div className="form-check form-check-inline">
                            <Controller
                              render={({ field }) => (
                                <input
                                  {...field}
                                  className="form-check-input"
                                  type="radio"
                                  id="cod-yes"
                                  value="1"
                                  checked={isCOD === "1"}
                                  onChange={(e) => {
                                    handleChangeIsCOD(e);
                                  }}
                                />
                              )}
                              name="is_cod"
                              control={control}
                              defaultValue="1"
                            />
                            <label
                              className="form-check-label"
                              htmlFor="cod-yes"
                            >
                              Yes
                            </label>
                          </div>
                        </div>
                        <div className="col-md-3 col-sm-12 col-12">
                          <div className="form-check form-check-inline">
                            <Controller
                              render={({ field }) => (
                                <input
                                  {...field}
                                  className="form-check-input"
                                  type="radio"
                                  id="cod-no"
                                  value="0"
                                  checked={isCOD === "0"}
                                  onChange={(e) => {
                                    handleChangeIsCOD(e);
                                  }}
                                />
                              )}
                              name="is_cod"
                              control={control}
                              defaultValue="0"
                            />
                            <label
                              className="form-check-label"
                              htmlFor="cod-no"
                            >
                              No
                            </label>
                          </div>
                        </div>
                      </div>
                    </div>
                  )}
                {watchFields["cons_type"] &&
                  watchFields["cons_type"] === "address" &&
                  isCOD === "0" && (
                    <React.Fragment>
                      <div className="col-sm-6 col-12">
                        <div className="form-group mb-4">
                          <label
                            htmlFor="base_fee"
                            className="font-12 font-bold d-flex justify-content-between align-items-center"
                          >
                            <span>Base Fee</span>
                          </label>
                          <Controller
                            render={({ field }) => (
                              <MaskedInput
                                {...field}
                                mask={numberMask(false)}
                                className="form-control rounded-8px"
                              />
                            )}
                            name="base_fee"
                            control={control}
                            rules={{
                              required: "Please input base fee",
                              validate: (base_fee) => {
                                if (parseFloat(formatDB(base_fee || 0)) < 0) {
                                  return "Base Fee min 0";
                                }
                                return true;
                              },
                            }}
                          />
                          {errors.base_fee && (
                            <small className="form-text text-error">
                              {errors?.base_fee?.message}
                            </small>
                          )}
                        </div>
                      </div>
                      <div className="col-sm-6 col-12">
                        <div className="form-group mb-4">
                          <label
                            htmlFor="max_distance_value"
                            className="font-12 font-bold d-flex justify-content-between align-items-center"
                          >
                            <span>Max Distance (Km)</span>
                          </label>
                          <Controller
                            render={({ field }) => (
                              <MaskedInput
                                {...field}
                                mask={numberMask(false)}
                                className="form-control rounded-8px"
                              />
                            )}
                            name="max_distance_value"
                            control={control}
                            rules={{
                              required: "Please input max distance",
                              validate: (max_distance_value) => {
                                if (
                                  parseFloat(
                                    formatDB(max_distance_value || 0)
                                  ) < 0
                                ) {
                                  return "Max Distance min 0";
                                }
                                return true;
                              },
                            }}
                            defaultValue={formData?.max_distance_value || 0}
                          />
                          {errors.max_distance_value && (
                            <small className="form-text text-error">
                              {errors?.max_distance_value?.message}
                            </small>
                          )}
                        </div>
                      </div>
                      <div className="col-sm-6 col-12">
                        <div className="form-group mb-4">
                          <label
                            htmlFor="max_distance_free"
                            className="font-12 font-bold d-flex justify-content-between align-items-center"
                          >
                            <span>Max Distance Free (Km)</span>
                          </label>
                          <Controller
                            render={({ field }) => (
                              <MaskedInput
                                {...field}
                                mask={numberMask(false)}
                                className="form-control rounded-8px"
                              />
                            )}
                            name="max_distance_free"
                            control={control}
                            rules={{
                              required: "Please input max distance free",
                              validate: (max_distance_free) => {
                                if (
                                  parseFloat(formatDB(max_distance_free || 0)) <
                                  0
                                ) {
                                  return "Max Distance Free min 0";
                                }
                                return true;
                              },
                            }}
                            defaultValue={formData?.max_distance_free || 0}
                          />
                          {errors.max_distance_free && (
                            <small className="form-text text-error">
                              {errors?.max_distance_free?.message}
                            </small>
                          )}
                        </div>
                      </div>
                      <div className="col-sm-6 col-12">
                        <div className="form-group mb-4">
                          <label
                            htmlFor="max_weight_value"
                            className="font-12 font-bold d-flex justify-content-between align-items-center"
                          >
                            <span>Max Weight (gr)</span>
                          </label>
                          <Controller
                            render={({ field }) => (
                              <MaskedInput
                                {...field}
                                mask={numberMask(false)}
                                className="form-control rounded-8px"
                              />
                            )}
                            name="max_weight_value"
                            control={control}
                            rules={{
                              required: "Please input max weight",
                              validate: (max_weight_value) => {
                                if (
                                  parseFloat(formatDB(max_weight_value || 0)) <
                                  0
                                ) {
                                  return "Max Weight min 0";
                                }
                                return true;
                              },
                            }}
                            defaultValue={formData?.max_weight_value || 0}
                          />
                          {errors.max_weight_value && (
                            <small className="form-text text-error">
                              {errors?.max_weight_value?.message}
                            </small>
                          )}
                        </div>
                      </div>
                      <div className="col-12">
                        <div className="form-group mb-4">
                          <label className="font-14 font-bold d-flex justify-content-between align-items-center">
                            Max Dimension
                          </label>
                        </div>
                      </div>
                      <div className="col-sm-4 col-12">
                        <div className="form-group mb-4">
                          <label
                            htmlFor="max_dimension_length"
                            className="font-12 font-bold d-flex justify-content-between align-items-center"
                          >
                            <span>Max Length (cm)</span>
                          </label>
                          <Controller
                            render={({ field }) => (
                              <MaskedInput
                                {...field}
                                mask={numberMask(false)}
                                className="form-control rounded-8px"
                              />
                            )}
                            name="max_dimension_length"
                            control={control}
                            rules={{
                              required: "Please input max length",
                              validate: (max_dimension_length) => {
                                if (
                                  parseFloat(
                                    formatDB(max_dimension_length || 0)
                                  ) < 0
                                ) {
                                  return "Max Length min 0";
                                }
                                return true;
                              },
                            }}
                            defaultValue={formData?.max_dimension_length || 0}
                          />
                          {errors.max_dimension_length && (
                            <small className="form-text text-error">
                              {errors?.max_dimension_length?.message}
                            </small>
                          )}
                        </div>
                      </div>
                      <div className="col-sm-4 col-12">
                        <div className="form-group mb-4">
                          <label
                            htmlFor="max_dimension_width"
                            className="font-12 font-bold d-flex justify-content-between align-items-center"
                          >
                            <span>Max Width (cm)</span>
                          </label>
                          <Controller
                            render={({ field }) => (
                              <MaskedInput
                                {...field}
                                mask={numberMask(false)}
                                className="form-control rounded-8px"
                              />
                            )}
                            name="max_dimension_width"
                            control={control}
                            rules={{
                              required: "Please input max width",
                              validate: (max_dimension_width) => {
                                if (
                                  parseFloat(
                                    formatDB(max_dimension_width || 0)
                                  ) < 0
                                ) {
                                  return "Max Width min 0";
                                }
                                return true;
                              },
                            }}
                            defaultValue={formData?.max_dimension_width || 0}
                          />
                          {errors.max_dimension_width && (
                            <small className="form-text text-error">
                              {errors?.max_dimension_width?.message}
                            </small>
                          )}
                        </div>
                      </div>
                      <div className="col-sm-4 col-12">
                        <div className="form-group mb-4">
                          <label
                            htmlFor="max_dimension_height"
                            className="font-12 font-bold d-flex justify-content-between align-items-center"
                          >
                            <span>Max Height (cm)</span>
                          </label>
                          <Controller
                            render={({ field }) => (
                              <MaskedInput
                                {...field}
                                mask={numberMask(false)}
                                className="form-control rounded-8px"
                              />
                            )}
                            name="max_dimension_height"
                            control={control}
                            rules={{
                              required: "Please input max height",
                              validate: (max_dimension_height) => {
                                if (
                                  parseFloat(
                                    formatDB(max_dimension_height || 0)
                                  ) < 0
                                ) {
                                  return "Max Height min 0";
                                }
                                return true;
                              },
                            }}
                            defaultValue={formData?.max_dimension_height || 0}
                          />
                          {errors.max_dimension_height && (
                            <small className="form-text text-error">
                              {errors?.max_dimension_height?.message}
                            </small>
                          )}
                        </div>
                      </div>
                    </React.Fragment>
                  )}
                <div className="col-12">
                  <div className="form-group text-right mt-4">
                    <button
                      type="button"
                      className="btn btn-default border-0 mr-3"
                      onClick={handleCancel}
                    >
                      Cancel
                    </button>
                    <button type="submit" className="btn btn-blue border-0">
                      Save
                    </button>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </form>
      </ModalBody>
    </Modal>
  );
};

export default FormDialog;
